import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';

import { bindAll } from '@bibliocommons/utils-react';

export class DownloadCheckoutLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleDownloadLinkClick() {
    const { bibId, itemPosition, itemPositionGrouped, totalCount, trackCheckoutConsumeDownload } = this.props;

    if (typeof trackCheckoutConsumeDownload === 'function') {
      trackCheckoutConsumeDownload({
        bibId,
        ui: {
          ui_content_position: itemPosition,
          ui_content_position_grouped: itemPositionGrouped,
          ui_content_position_grouped_count: totalCount
        }
      });
    }
  }

  render() {
    const { className } = this.props;

    return (
      <a
        href={this.props.downloadUrl}
        onClick={this.handleDownloadLinkClick}
        className={cn('cp-download-checkout-link', className)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id={`download_now_${this.props.format.toLowerCase()}`}
          defaultMessage={this.props.intl.formatMessage(
            {
              id: 'download_now_format'
            },
            {
              format: this.props.intl.formatMessage({
                id: `digiformat_${this.props.format.toLowerCase()}`
              })
            }
          )}
        />
      </a>
    );
  }
}

DownloadCheckoutLink.propTypes = {
  className: PropTypes.string,
  downloadUrl: PropTypes.string,
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  totalCount: PropTypes.number,
  format: PropTypes.string,
  bibId: PropTypes.string,
  trackCheckoutConsumeDownload: PropTypes.func
};

export default injectIntl(DownloadCheckoutLink);
